import { render, staticRenderFns } from "./taittinger.vue?vue&type=template&id=54cb51fa&scoped=true"
import script from "./taittinger.vue?vue&type=script&lang=js"
export * from "./taittinger.vue?vue&type=script&lang=js"
import style0 from "./taittinger.vue?vue&type=style&index=0&id=54cb51fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb51fa",
  null
  
)

export default component.exports